
// src/web/components/notifications-page.jsx

import React from 'react'
import connect from '../../connects/notifications-page'
import RightSidePage from './right-side-page.jsx'
import diaryFormsTabTheme from './themes/diary-forms-tab.css'
import AnnouncesTab from './announces-tab.jsx'
import NotificationTab from './notifications-tab'
import notificationBadge from './themes/new-badge.css'
import {
  Tab,
  Tabs
} from 'react-toolbox/lib/tabs'
import { IconButton } from 'react-toolbox/lib/button'
import Tooltip from 'react-toolbox/lib/tooltip'
const TooltipIconButton = Tooltip(IconButton)

class NotificationsPage extends React.Component {
  fetchNotifications = ()=> !this.props.isFetching && this.props.fetchNotifications(this.props)
  changeTab = (tabIndex) => this.props.updateUI({ tabIndex })
  openUrlPage = (url) => window.open(url)
  render() {
    const {
      t,
      ui,
      group_id,
      openNotificationrSettingsPage,
    } = this.props
  
    return (
      <RightSidePage title={t('label:新着の通知')} icon="notifications" 
        rightAction={[
          <TooltipIconButton icon='settings' key="settings-notification" tooltip={t('label:通知設定')}
            onClick={()=> openNotificationrSettingsPage()} />
        ]}>
          <Tabs fixed index={ui.tabIndex} onChange={this.changeTab} theme={diaryFormsTabTheme}>
            <Tab label={t('label:通知')}>
              <NotificationTab group_id={group_id} />
            </Tab>
            <Tab label={<div style={{ display: 'flex', justifyContent: 'center', textTransform: 'none'}}>
              {t('label:gambaから')}
              {!this.props.close && <div className={notificationBadge.notification} /> || null}
              </div>}>
                <AnnouncesTab />
            </Tab>
          </Tabs>
      </RightSidePage>
    )
  }
}

export const RawNotificationsPage = NotificationsPage
export default connect(NotificationsPage)



// WEBPACK FOOTER //
// ./src/web/components/notifications-page.jsx